import React from 'react';
import { motion } from 'framer-motion';
import { teamMembersData } from './teamData';
import TeamMemberItem from './TeamMemberItem';

const testimonials = [
  `“Guidepost has been the most amazing experience for our family! My son LOVES to go see Kat every week and they always give us the best tips and ideas to implement during the week at home, school and tutoring.”`,
  `"Susan and her team of therapists are AMAZING! I have two kiddos in PT, OT and speech and they LOVE going to their sessions. Susan is very supportive and goes above and beyond our expectations.”`,
  `“Dear Susan…I am enchanted by the wonderful environment you have created for your clients to come and play and grow… I can tell you have a beautiful soul and make a huge difference a many lives. Thank you.” `,
];

const vectorArts = [
  {
    src: 'vector_art_one.png',
    position: 'left',
    top: '5%',
    startX: '-60%',
    endX: '100%',
  },
  {
    src: 'vector_art_two.png',
    position: 'right',
    top: '20%',
    startX: '200%',
    endX: '0%',
  },
  {
    src: 'vector_art_three.png',
    position: 'left',
    top: '35%',
    startX: '0%',
    endX: '200%',
  },
  {
    src: 'vector_art_four.png',
    position: 'right',
    top: '50%',
    startX: '50%',
    endX: '0%',
  },
  {
    src: 'vector_art_five.png',
    position: 'left',
    top: '60%',
    startX: '0%',
    endX: '200%',
  },
  {
    src: 'vector_art_six.png',
    position: 'right',
    top: '75%',
    startX: '50%',
    endX: '0%',
  },
  {
    src: 'vector_art_two.png',
    position: 'left',
    top: '85%',
    startX: '0%',
    endX: '200%',
  },
];

const TeamMembers = () => {
  return (
    <div className="relative bg-gradient-to-b from-[#C672A7] via-[#5F5FA4] to-[#C06FA6] overflow-hidden">
      <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 md:gap-24 max-w-[1238px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        {teamMembersData.map((member, index) => (
          <React.Fragment key={member.id}>
            <TeamMemberItem member={member} />
            {(index + 1) % 3 === 0 && testimonials[Math.floor(index / 3)] && (
              <p className="text-white font-bold text-lg md:text-xl 2xl:text-[32px] text-center max-w-[941px] mx-auto">
                {testimonials[Math.floor(index / 3)]}
              </p>
            )}
          </React.Fragment>
        ))}
      </div>

      {vectorArts.map((art, index) => (
        <motion.img
          key={index}
          loading="lazy"
          src={require(`../../../assets/images/team_screen/${art.src}`)}
          alt={`Vector Art ${index + 1}`}
          className="absolute h-auto"
          style={{ top: art.top }}
          initial={{ x: art.startX }}
          animate={{ x: art.endX }}
          transition={{
            duration: 60,
            repeat: Infinity,
            repeatType: 'reverse',
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};

export default TeamMembers;
